module.exports = __webpack_public_path__ + "img/icon_whatsapp.5ffa11f.svg";